export default function TermsOfService() {
  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: 'auto' }}>
      <h1>Terms of Service</h1>

      <section>
        <h2>1. Introduction</h2>
        <p>Please read the Terms of Service carefully before using the website...</p>
      </section>

      <section>
        <h2>2. Permitted Use</h2>
        <p>You may use the website only for permitted purposes...</p>
      </section>

      <section>
        <h2>3. Accounts and Security</h2>
        <p>Some parts of the website may require creating an account...</p>
      </section>

      <section>
        <h2>4. Intellectual Property Rights</h2>
        <p>It is prohibited to republish, copy, or modify any content...</p>
      </section>

      <footer>
        <p>
          For any inquiries, please contact us via email at{' '}
          <a href="mailto:support@yourwebsite.com">support@yourwebsite.com</a>.
        </p>
      </footer>
    </div>
  );
}
